/*
 * Public API Surface of shared
 */

// Dates
export * from './date/convert-date-str-to-js';
export * as dates from './date/dates';

// Translation helpers
export * from './shared-form/__i18n__/helpers';

// Schemas and related translations
export * as sharedSchemas from './shared-form/shared-forms.schema';
export * as sharedI18n_EN_US from './shared-form/__i18n__/shared-form.i18n.en-US';
export * as sharedI18n_PT_PT from './shared-form/__i18n__/shared-form.i18n.pt-PT';
export * as sharedAppI18n_EN_US from './shared-app/__i18n__/shared-app.i18n.en-US';
export * as sharedAppI18n_PT_PT from './shared-app/__i18n__/shared-app.i18n.pt-PT';

// Catalogs and related translations
// Countries
import * as countriesCatalogs from './catalog/countries';
import * as countriesCatalogsI18n_EN_US from './catalog/countries.i18n.en-US';
import * as countriesCatalogsI18n_PT_PT from './catalog/countries.i18n.pt-PT';
// Server catalogs (if present)
import * as serverCatalogs from './catalog/server/serverCatalogs';

export const catalogs = {
  countries: {
    catalogs: countriesCatalogs,
    i18n_en_US: countriesCatalogsI18n_EN_US,
    i18n_pt_PT: countriesCatalogsI18n_PT_PT,
  },
  serverCatalogs
};

// Configs
export * from './shared-config/config';
export * from './shared-config/xsrf-token-extractor';
